module.exports = __webpack_public_path__ + "media/images/spinner-d571d20a0f39bbbc58afa02950cac456.svg";